import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { DeliverySlot } from '~/api/ETA';
import Icon from '~/components/Icon/Icon';
import { useDateLang } from '~/hooks/useDateLang';
import { useTimeFormat } from '~/hooks/useTimeFormat';
import { getSelectedDaySplited } from '~/pages/Checkout/utils';
import { checkoutStore, orderStore } from '~/stores';

interface UseDeliverySlotDatesParams {
  slot?: DeliverySlot;
  previousDeliverySlot?: DeliverySlot;
  expressDeliveryLabelClassName?: string;
}

export const useDeliverySlotDates = ({
  slot,
  previousDeliverySlot,
  expressDeliveryLabelClassName,
}: UseDeliverySlotDatesParams) => {
  const { t } = useTranslation();
  const { locale } = useDateLang();
  const { timeFormat } = useTimeFormat();

  const getExpressDeliveryLabel = (time?: string): ReactNode => (
    <p className={expressDeliveryLabelClassName}>
      <Icon type="flash-fill" />
      <span>
        {t('phrases:deliveryInMin', {
          time: time ?? orderStore.etaCalculation?.duration.range,
        })}
      </span>
    </p>
  );

  const getPreviousExpressTime = (): string => {
    const previousExpressTime =
      checkoutStore.slotsChangedEventStore.previousExpressTime;
    if (previousExpressTime === '0 - 0') {
      return `30 ${t('min')}`;
    }
    return (
      previousExpressTime ?? orderStore.etaCalculation?.duration.range ?? ''
    );
  };

  const selectedDay: ReactNode = slot
    ? getSelectedDaySplited(slot, timeFormat, locale).date
    : getExpressDeliveryLabel();

  const previousSelectedDate: ReactNode = previousDeliverySlot
    ? getSelectedDaySplited(previousDeliverySlot, timeFormat, locale).date
    : getExpressDeliveryLabel(getPreviousExpressTime());

  return {
    selectedDay,
    previousSelectedDate,
  };
};
